import { z } from 'zod';

export const CategoryRow = z.object({
  id: z.number().int().positive(),
  parent_id: z.number().int().positive().nullable(),
  type: z.enum(['theme', 'kids', 'color', 'room', 'style', 'combi', 'featured']),
  public: z.boolean(),
  menu: z.boolean(),
  cover: z.string().nullable(),
  sort: z.number().int().min(0),
  combi: z.record(z.unknown()),
  created_at: z.string().datetime(),
  updated_at: z.string().datetime(),
});
export type Category = z.infer<typeof CategoryRow>;

const base = {
  cover: null,
  combi: {},
  created_at: '2026-01-01T00:00:00.000Z',
  updated_at: '2026-01-01T00:00:00.000Z',
} as const;

export const CATEGORIES: readonly Category[] = [
  // themes (5)
  { id: 1,  parent_id: null, type: 'theme', public: true, menu: true,  sort: 1, ...base },
  { id: 2,  parent_id: null, type: 'theme', public: true, menu: true,  sort: 2, ...base },
  { id: 3,  parent_id: null, type: 'theme', public: true, menu: true,  sort: 3, ...base },
  { id: 4,  parent_id: null, type: 'theme', public: true, menu: true,  sort: 4, ...base },
  { id: 5,  parent_id: null, type: 'theme', public: true, menu: true,  sort: 5, ...base },
  // rooms (5)
  { id: 6,  parent_id: null, type: 'room',  public: true, menu: true,  sort: 1, ...base },
  { id: 7,  parent_id: null, type: 'room',  public: true, menu: true,  sort: 2, ...base },
  { id: 8,  parent_id: null, type: 'room',  public: true, menu: true,  sort: 3, ...base },
  { id: 9,  parent_id: null, type: 'room',  public: true, menu: true,  sort: 4, ...base },
  { id: 10, parent_id: null, type: 'room',  public: true, menu: true,  sort: 5, ...base },
  // styles (4)
  { id: 11, parent_id: null, type: 'style', public: true, menu: false, sort: 1, ...base },
  { id: 12, parent_id: null, type: 'style', public: true, menu: false, sort: 2, ...base },
  { id: 13, parent_id: null, type: 'style', public: true, menu: false, sort: 3, ...base },
  { id: 14, parent_id: null, type: 'style', public: true, menu: false, sort: 4, ...base },
  // colors (4)
  { id: 15, parent_id: null, type: 'color', public: true, menu: false, sort: 1, ...base },
  { id: 16, parent_id: null, type: 'color', public: true, menu: false, sort: 2, ...base },
  { id: 17, parent_id: null, type: 'color', public: true, menu: false, sort: 3, ...base },
  { id: 18, parent_id: null, type: 'color', public: true, menu: false, sort: 4, ...base },
  // combi (2)
  { id: 19, parent_id: null, type: 'combi', public: true, menu: false, sort: 1, ...base, combi: { theme: 1, room: 6 } },
  { id: 20, parent_id: null, type: 'combi', public: true, menu: false, sort: 2, ...base, combi: { theme: 2, color: 15 } },
] as const;

CATEGORIES.forEach((c) => CategoryRow.parse(c));
